import { render, staticRenderFns } from "./TaskPriorityFilter.vue?vue&type=template&id=0f35e8a6&scoped=true"
import script from "./TaskPriorityFilter.vue?vue&type=script&lang=ts"
export * from "./TaskPriorityFilter.vue?vue&type=script&lang=ts"
import style0 from "./TaskPriorityFilter.vue?vue&type=style&index=0&id=0f35e8a6&prod&lang=scss&scoped=true"
import style1 from "./TaskPriorityFilter.vue?vue&type=style&index=1&id=0f35e8a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f35e8a6",
  null
  
)

export default component.exports